import { Vue } from 'vue-property-decorator'
import { ServiceObservationRepository } from './ServiceObservationRepository'
import { JtechStore } from 'src/plugins/mobx'

export default class ServiceObservationController {
  static getInstance () {
    return JtechStore.getSingleton('ServiceObservationController', new ServiceObservationController())
  }

  async loadDatatable () {
    return await ServiceObservationRepository.loadDatatable()
  }

  async loadDatatableModel (params) {
    return await ServiceObservationRepository.loadDatatableModel(params)
  }

  async loadForm () {
    return await ServiceObservationRepository.loadForm()
  }

  async createServiceObservation (params) {
    return await ServiceObservationRepository.createServiceObservation(params)
  }
}
